import { I18n as I18nPackage } from 'i18n-js';

let i18nHelper = new I18nPackage();
const translator = {
  t(key, parameters = {}) {
    return i18nHelper.t(key, parameters);
  },
  strftime(date, format) {
    return i18nHelper.t(date, format);
  },
  setTranslations(translations) {
    i18nHelper.translations = translations;
  }
};

Object.freeze(translator);
export { translator };
